import React from "react"
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  RefreshButton,
  CreateButton,
  Filter,
  TextInput,
} from "admin-on-rest"

import ChartIcon from "material-ui/svg-icons/editor/insert-chart"
import { CardActions } from "material-ui/Card"
import "./index.css"
import IconTitle from "../components/icon_title"
import Pagination from "../components/pagination"
import {
  TemplateCreate as create,
  TemplateEdit as edit,
  TemplateShow as show,
} from "./Create"
import { LinkButton } from "../components"

export const TemplateCreate = create
export const TemplateEdit = edit
export const TemplateShow = show
export { default as EditorLayout } from "./EditorLayout"

const TemplateActions = ({ resource, basePath, refresh }) => (
  <CardActions className="contents-actions">
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
)
const TemplateFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
)
//filters={<TemplateFilter />}
export const TemplateList = (props) => (
  <List
    {...props}
    filters={<TemplateFilter />}
    actions={<TemplateActions />}
    title={<IconTitle icon="pages" title={"resources.contents.title"} />}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.contents.field.title" source="title" />
      <LinkButton
        {...props}
        icon={<ChartIcon />}
        style={{ textAlign: "right", width: 50 }}
        urlPath={"/chart"}
      />
      <EditButton label="" style={{ textAlign: "right", width: 80 }} />
    </Datagrid>
  </List>
)



// WEBPACK FOOTER //
// ./src/contents/index.js